import { Axios } from 'commonUtils';

class AdvancedSearchApi {
  findItems = async () => {
    return await Axios.getData(`/spr/advancedSearch`);
  };
}

export default AdvancedSearchApi;
